interface megaethIconProps {
  className?: string
  size?: number
}

export const megaethIcon: React.FC<megaethIconProps> = ({
  className,
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1471 29.5908L28.0868 29.5911L23.4573 15.7849L17.2275 15.8215L17.1101 35.6444C18.1859 35.0718 19.4058 34.5826 20.7336 34.1892L20.8069 21.8134L20.8765 20.2224L26.318 33.2527C27.0293 33.1882 27.2343 33.1629 27.9693 33.1586C28.7043 33.1543 28.8969 33.1893 29.6076 33.2333L35.2046 19.9937L35.2554 21.584L35.1813 34.1043C36.4924 34.4822 37.7066 34.9571 38.7877 35.5171L38.9051 15.6942L32.6754 15.7308L28.135 29.5908L28.1471 29.5908Z"
        fill="currentColor"
      />
      <path
        d="M22.9099 43.1502C24.2476 43.1424 25.3384 42.0516 25.3463 40.7139C25.3542 39.3762 24.2763 38.2981 22.9386 38.306C21.601 38.3138 20.5102 39.4046 20.5023 40.7423C20.4943 42.08 21.5723 43.1581 22.9099 43.1502Z"
        fill="currentColor"
      />
      <path
        d="M32.9118 43.0915C34.2494 43.0837 35.3402 41.9929 35.3482 40.6552C35.3561 39.3174 34.2781 38.2394 32.9405 38.2472C31.6029 38.2551 30.5121 39.3459 30.5042 40.6836C30.4963 42.0213 31.5742 43.0994 32.9118 43.0915Z"
        fill="currentColor"
      />
      <path
        d="M28.1647 0.163623C12.8133 0.25381 0.255637 12.8114 0.164695 28.1636C0.0737534 43.5159 12.4835 55.9268 27.8349 55.8366C43.1864 55.7464 55.744 43.1888 55.8349 27.8366C55.9259 12.4843 43.5162 0.073436 28.1647 0.163623ZM27.8569 52.125C14.5539 52.2032 3.79726 41.4455 3.87606 28.1418C3.95487 14.8382 14.8397 3.9533 28.1427 3.87515C41.4458 3.797 52.2023 14.5547 52.1235 27.8584C52.0447 41.162 41.1599 52.0469 27.8569 52.125Z"
        fill="currentColor"
      />
    </svg>
  )
}
